// src/admin/ManageEvents.js

import React, { useState, useEffect } from 'react';
import { db } from '../config/firebaseConfig';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import EditEventModal from './EditEventModal'; 

const ManageEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Modal görünürlük ve seçili etkinlik stateleri[cite: 3]
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Firestore'dan etkinlikleri çeken fonksiyon[cite: 3]
  const fetchEvents = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'events'));
      const eventsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEvents(eventsList);
    } catch (err) {
      console.error("Error fetching events: ", err);
      setError('Failed to load events. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Component yüklendiğinde verileri getirir[cite: 3]
  useEffect(() => {
    fetchEvents();
  }, []);

  // Düzenleme butonuna basıldığında tetiklenen fonksiyon[cite: 3]
  const handleEdit = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  // Modalı güvenli bir şekilde kapatır ve state'i temizler[cite: 3]
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };
  
  // Düzenleme işlemi bittiğinde arayüz listesini günceller[cite: 3]
  const handleEventUpdated = (updatedEvent) => {
    setEvents(events.map(event => event.id === updatedEvent.id ? updatedEvent : event));
    fetchEvents(); 
  };

  // Etkinlik silme fonksiyonu[cite: 3]
  const handleDelete = async (eventId) => {
    if (window.confirm('Are you sure you want to delete this event? This action cannot be undone.')) {
      try {
        await deleteDoc(doc(db, 'events', eventId));
        setEvents(events.filter(event => event.id !== eventId));
        alert('Event deleted successfully!');
      } catch (err) {
        console.error("Error deleting event: ", err);
        alert('Failed to delete event.');
      }
    }
  };

  if (loading) {
    return <div className="container mt-5 text-center">Loading events...</div>;
  }

  if (error) {
    return <div className="container mt-5 alert alert-danger">{error}</div>;
  }

  return (
    <div className="container mt-5">
      <h2>Manage Events</h2>
      <p>Here you can view, edit, or delete existing events.</p>
      
      {events.length === 0 ? (
        <p>No events found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th>Poster</th>
                <th>Event Name</th>
                <th>Location</th>
                <th>Date</th>
                <th>Time</th>
                <th>Link</th> {/* Yeni eklenen tablo başlığı */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td>
                    <img src={event.posterUrl} alt={event.name} style={{ width: '100px', height: 'auto' }} />
                  </td>
                  <td>{event.name}</td>
                  <td>{event.location}</td>
                  <td>{event.date}</td>
                  <td>{event.time}</td>
                  <td>
                    {/* Yeni eklenen Link hücresi içeriği */}
                    {event.eventLink ? (
                      <a 
                        href={event.eventLink} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn btn-link btn-sm p-0"
                      >
                        View Link
                      </a>
                    ) : (
                      <span className="text-muted small">No Link</span>
                    )}
                  </td>
                  <td>
                    <button 
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => handleEdit(event)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(event.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Seçili etkinlik mevcutsa düzenleme modalını tetikler[cite: 3] */}
      {selectedEvent && (
        <EditEventModal
          show={showModal}
          handleClose={handleCloseModal}
          event={selectedEvent}
          onEventUpdate={handleEventUpdated}
        />
      )}
    </div>
  );
};

export default ManageEvents;